/* eslint-disable  */
//@ts-nocheck

import auth from '@client/components/auth';
import { useGetDraftWorkoutsQuery } from '../../../../generated/graphql';
import React from 'react';
import { browserHistory } from 'react-router';
import { WorkoutList } from './components/WorkoutList';
import { WorkoutsPage } from './components/WorkoutsPage';
import { isEmpty } from 'lodash';

export function DraftWorkoutsPage(props) {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const url = new URL(window.location.href);
  const shouldRefresh = url.searchParams.get('refresh');

  const {
    loading: isLoading,
    data,
    refetch,
  } = useGetDraftWorkoutsQuery({
    variables: { id: parseInt(influencerId) },
    skip: !influencerId,
    fetchPolicy: 'network-only', // NOTE: need to avoid issues after publishing
    onCompleted: () => {
      if (shouldRefresh) {
        url.searchParams.delete('refresh');
        browserHistory.replace(url.href);
      }
    },
  });

  const doesNotHaveData = !data?.creator;

  const workouts = doesNotHaveData ? [] : data.creator.draftWorkouts;

  return (
    <WorkoutsPage
      isLoading={isLoading}
      creator={data ? data.creator : { id: influencerId }}
    >
      <WorkoutList
        type="draft"
        refreshWorkouts={refetch}
        workouts={workouts}
        influencerId={influencerId}
      />
    </WorkoutsPage>
  );
}
